export const KILL_SWITCH_INFO_ROUTE = 'KILL-SWITCH-INFO';
export const PDF_PREVIEW_ROUTE = 'PDF-PREVIEW';

export const bizMinVersionConfigs = {
  [KILL_SWITCH_INFO_ROUTE]: '1.6.3',
  [PDF_PREVIEW_ROUTE]: '2.6.0', // attention: live version may be different
};
